import { ReduxStore } from '~/App/shared/interfaces/store';
import { SetFeatureFlagAction, SET_FEATURE_FLAG_TYPE } from './actions';

const featureFlagReducer = (
  state = {} as ReduxStore['featureFlags'],
  action: SetFeatureFlagAction
) => {
  switch (action.type) {
    case SET_FEATURE_FLAG_TYPE:
      return {
        ...state,
        flags: {
          ...state.flags,
          ...action.payload
        }
      };

    default:
      return state;
  }
};

export default featureFlagReducer;
